import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/observable';
import { InterceptorAuthProvider } from '../../providers/interceptor-auth/interceptor-auth';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    interceptorAuth: InterceptorAuthProvider
    
    constructor(public injector: Injector){ }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.interceptorAuth = this.injector.get(InterceptorAuthProvider);
        const token = this.interceptorAuth.getLinkToken();
        const authReq = req.clone({
          headers: req.headers.set('Authorization', 'Bearer ' + token)
        });
        return next.handle(authReq);
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/auth.ts